import Styles from './CampaignContext.module.scss'
import { UploadButton } from './UploadButton'
import { AddWebpageButton } from './AddWebpageModal/AddWebpageButton'
import { Source } from 'types'
import { Text } from 'blaze-ui/Text/Text'
import React from 'react'

export const EmptyState = ({ onSourceCreated }: { onSourceCreated: (source: Source) => Promise<any> | void }) => {
  return (
    <div className={Styles.emptyState}>
      <Text lineClamp={1} variant="secondary" color="var(--dark-80)">
        Add more context
      </Text>
      <div className={Styles.optionActions}>
        <Text variant="placeholder" lineClamp={1}>
          Websites, docs, PDFs, videos, voice notes
        </Text>
        <AddWebpageButton variant="ghost" onSourceCreated={onSourceCreated} />
        <UploadButton variant="ghost" onSourceCreated={onSourceCreated}>
          Upload
        </UploadButton>
      </div>
    </div>
  )
}
